module.exports = __webpack_public_path__ + "img/s_6.19c471c5.png";